import React, { FC } from "react";

export interface TermsGridItem {
  label: string;
  value: string;
}

export interface TermsGridProps {
  items: TermsGridItem[];
  className?: string;
}

/**
 * Two facts side by side on a hairline, e.g. the property and the rental period
 * above the contract. The 1px gap plus a `line`-coloured ground is what draws
 * the divider between the cells.
 */
const TermsGrid: FC<TermsGridProps> = ({ items, className = "" }) => (
  <div
    className={`grid grid-cols-1 gap-px border border-line bg-line min-[760px]:grid-cols-2 ${className}`}
  >
    {items.map((item) => (
      <div key={item.label} className="bg-[#faf9f6] px-4 py-[14px]">
        <small className="block text-[12px] uppercase tracking-[0.1em] text-[#999] min-[760px]:text-[11px]">
          {item.label}
        </small>
        <strong className="block text-[12px] font-bold text-navy min-[760px]:text-[14px]">
          {item.value}
        </strong>
      </div>
    ))}
  </div>
);

export default TermsGrid;
